import { Card } from "@hdi-seguros/web-components.card";
import { Row, Typography } from "antd";
import { _renderColumns } from '../../../../../shared/components/CardRenderWithButton/renderSections';
import { FC } from "react";
import './index.css';

interface TotalProductionCardProps {
    title: string;
    article: string | undefined;
    actions?: any;
    loading: boolean | undefined;
    columnsData: Array<any>;
}

const _renderTitle = (title: string) => (
    <>
      <Typography.Text className="total-production_card-title" strong>
        {' '}
        {title}
      </Typography.Text>
    </>
);

export const TotalProductionCardComponent: FC<TotalProductionCardProps> = ({title, article, actions, loading, columnsData}) => {
    return (
      <Card
        title={_renderTitle(title)}
        actions={actions}
        loading={loading}
        style={{
          marginBottom: 20,
          width: '100%',
        }}
      >
        <Row style={{ marginLeft: 0 }} gutter={[10, 10]}>
          {_renderColumns(columnsData)}
        </Row>
      </Card>
    )
}